import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-drop-down-arrow',
  templateUrl: './drop-down-arrow.component.html',
  styleUrls: ['./drop-down-arrow.component.scss']
})
export class DropDownArrowComponent implements OnInit {

  //carrot defaults to pointing down - use below values to change direction
  @Input() pointLeft = false;
  @Input() pointRight = false;
  @Input() pointUp = false;
  @Input() stroke: string = 'white';

  @Input() size: string = null;

  //default - SMALL
  height: string = '20px';
  width: string = '10px';

  constructor() {}

  ngOnInit(): void {
    if(this.size == 'large'){
      this.height = '50px';
      this.width = '25px';
    }
    //add more settings as needed.
  }

}
